module.exports = __webpack_public_path__ + "static/media/arrow.4fd94eec.svg";